<template>
  <div class="add-form">
    <div class="back-title">
      <span @click="onCancel"><i class="el-icon-back" /> 返回上一级</span>
    </div>

    <div class="form-title">
      <span v-if="pid">{{ form.name }} 的用户组信息</span>
      <span v-else>新增用户组</span>
    </div>

    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="120px"
             label-position="left">
      <el-form-item label="组名"
                    prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="备注信息">
        <el-input v-model="form.remarks"
                  type="textarea"
                  rows="3"
                  placeholder="请输入备注信息" />
      </el-form-item>
      <el-form-item label="组内用户">
        <el-select v-model="form.users"
                   multiple
                   filterable
                   style="width:400px;"
                   placeholder="请选择组内用户">
          <el-option v-for="u in allUsers"
                     :key="u.id"
                     :label="u.name"
                     :value="u.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="用户组类型">
        <el-select v-model="form.group_type"
                   filterable
                   style="width:400px;"
                   placeholder="请选择用户组类型">
          <el-option v-for="u in allGroupTypes"
                     :key="u.id"
                     :label="u.name"
                     :value="u.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSubmit">
          提交
        </el-button>
        <el-button @click="onCancel">
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  addUserGroup, updateUserGroup, queryUserGroupInfo, queryUser,
} from '@/api/admin';
import { mapActions } from 'vuex';

export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    pid: {
      default: null,
    },
  },
  data() {
    return {
      form: {
        users: [],
      },
      query: {
        page: 1,
        per_page: 10000,
      },
      allUsers: [],
      rules: {
        authorization: [{ required: true, message: '请输入用户类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入组名', trigger: 'blur' }],
      },
      allGroupTypes: [
        {
          id: 'normal',
          name: '常规标注',
        },
        {
          id: 'staff',
          name: '店员',
        },
      ],

    };
  },
  mounted() {
    this.getUsers();
    if (this.pid) {
      this.fetchData();
    }
  },
  methods: {
    ...mapActions(['getAllUsers']),
    fetchData() {
      const params = { id: this.pid };
      queryUserGroupInfo(params).then((res) => {
        if (res.data) {
          const result = res.data;
          result.users = result.users.map(item => item.id, 0);
          this.form = result;
        }
      });
    },
    getUsers() {
      this.getAllUsers().then((users) => {
        this.allUsers = users;
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form);
          if (this.pid) {
            updateUserGroup(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          } else {
            addUserGroup(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    onCancel() {
      this.$emit('setRPQ', { r: 'list', p: undefined });
    },
  },
};
</script>
